<template>
<body id="page-top" class="body-bg">
       <v-idle style="display:none !important;" @idle="onidle"
  @remind="onremind" :duration="10"/>
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio" id="portfolio">
            <div class="container cpt-10">
                <!-- Portfolio Grid Items-->
                <div class="row justify-content-center">
                    <!-- Portfolio Item 1-->
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal1">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn" ><router-link to="/member-login">  <img class="img-fluid" src="../assets/Philcare-Member.png" alt="..." /></router-link> </a>
                            <p class="h3">PhilCare Member</p>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </section>
</body>
</template>

<script>
export default {

  name: 'PhilLogin',
  props: {
    msg: String
  },
  methods: {
    onidle() {
        this.$router.push('/');
    },
    onremind(time) {
      // alert seconds remaining to 00:00
      alert(time);
    }
  },
  created() {
    if (localStorage.getItem('CertNo')) {
          this.$router.push('/member-page');
      }
  },
  
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
